export default "__VITE_ASSET__yzbvLmyx__"